module.exports = __webpack_public_path__ + "static/media/certificate2.0144ab72.webp";